function initializeFrozenCart(){
  const root=document.querySelector('[data-cart-section]');
  if(!root||root.dataset.ready)return;
  root.dataset.ready='true';
  const form=root.querySelector('form');if(!form)return;
  form.querySelectorAll('[data-qty-step]').forEach(b=>b.hidden=false);
  const feedback=root.querySelector('[data-cart-feedback]');
  let busy=false,failed=false,timer;
  const quantities=()=>Array.from(form.querySelectorAll('[data-cart-quantity]'));
  const checkout=form.querySelector('[name=checkout]');
  function dirty(){return quantities().some(i=>i.value!==i.dataset.original);}
  async function save(){
    clearTimeout(timer);if(busy||failed)return;
    if(!form.reportValidity()){checkout.disabled=true;feedback.textContent='Enter a whole quantity of zero or more.';return;}
    const changed=quantities().filter(i=>i.value!==i.dataset.original).reverse();
    if(!changed.length){checkout.disabled=false;return;}
    busy=true;root.setAttribute('aria-busy','true');feedback.textContent='Updating your cart…';
    const controls=Array.from(form.querySelectorAll('input,button'));controls.forEach(c=>c.disabled=true);
    try{
      let result;
      for(const input of changed){
        const response=await fetch(root.dataset.cartChange,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({line:Number(input.dataset.line),quantity:Number(input.value),sections:[root.dataset.cartSection],sections_url:location.pathname})});
        result=await response.json();
        if(!response.ok)throw new Error(typeof result.description==='string'?result.description:'Your cart could not be updated. Please try again.');
      }
      const markup=result.sections&&result.sections[root.dataset.cartSection];
      if(!markup){location.reload();return;}
      const parsed=new DOMParser().parseFromString(markup,'text/html');
      const fresh=parsed.querySelector('[data-cart-section]');
      if(!fresh){location.reload();return;}
      root.replaceWith(fresh);
      document.querySelectorAll('[data-cart-count]').forEach(el=>el.textContent=result.item_count);
      document.querySelectorAll('[data-cart-alert]').forEach(el=>el.hidden=result.item_count===0);
      document.querySelectorAll('[data-cart-link]').forEach(el=>el.setAttribute('aria-label','Cart, '+result.item_count+' items'));
      const status=fresh.querySelector('[data-cart-feedback]');status.textContent='Cart updated — quantities and totals refreshed.';status.tabIndex=-1;status.focus({preventScroll:true});
      fresh.classList.add('cart-just-updated');initializeFrozenCart();
    }catch(error){
      feedback.textContent=error.message+' Refresh the page to confirm the current quantities before checkout.';
      failed=true;
      controls.forEach(c=>c.disabled=true);
      const retry=form.querySelector('[name=update]');retry.hidden=false;retry.disabled=false;retry.textContent='REFRESH CART';
      feedback.tabIndex=-1;feedback.focus({preventScroll:true});
    }finally{busy=false;root.removeAttribute('aria-busy');}
  }
  form.addEventListener('click',event=>{const button=event.target.closest('[data-qty-step]');if(!button||busy||failed)return;const input=button.parentElement.querySelector('[data-cart-quantity]');const next=Math.max(0,(Number(input.value)||0)+Number(button.dataset.qtyStep));input.value=String(next);input.dispatchEvent(new Event('input',{bubbles:true}));});
  form.addEventListener('input',event=>{if(event.target.matches('[data-cart-quantity]')){checkout.disabled=true;feedback.textContent='Quantity changed — saving…';clearTimeout(timer);timer=setTimeout(save,600);}});
  form.addEventListener('change',event=>{if(event.target.matches('[data-cart-quantity]'))save();});
  form.addEventListener('click',event=>{const link=event.target.closest('[data-cart-remove]');if(link){event.preventDefault();if(busy)return;link.closest('[data-cart-row]').querySelector('[data-cart-quantity]').value='0';save();}});
  form.addEventListener('submit',event=>{
    if(failed){event.preventDefault();location.reload();return;}
    if(event.submitter?.name==='checkout'&&!busy&&!dirty())return;
    event.preventDefault();save();
  });
  form.querySelector('[name=update]').hidden=true;
}
document.addEventListener('DOMContentLoaded',initializeFrozenCart);
document.addEventListener('shopify:section:load',initializeFrozenCart);
